<div class="app-widget"
  [ngClass]="configuration.hostPresentationClass">
  <div class="content" >
    <ng-template component-host></ng-template>
  </div>
</div>